import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { stripLangPrefix } from "@/hooks/useLocalePath";

// Pages that should not be indexed by search engines
const NOINDEX_ROUTES = [
  "/account",
  "/auth",
  "/checkout",
  "/payment",
  "/order",
  "/orders",
];

export const useNoIndex = () => {
  const location = useLocation();

  useEffect(() => {
    // Strip language prefix before checking route
    const basePath = stripLangPrefix(location.pathname);

    const shouldNoIndex = NOINDEX_ROUTES.some(
      (route) => basePath === route || basePath.startsWith(`${route}/`)
    );

    // Find or create robots meta tag
    let robotsMeta = document.querySelector('meta[name="robots"]');
    
    if (shouldNoIndex) {
      if (!robotsMeta) {
        robotsMeta = document.createElement("meta");
        robotsMeta.setAttribute("name", "robots");
        document.head.appendChild(robotsMeta);
      }
      robotsMeta.setAttribute("content", "noindex, nofollow");
    } else {
      if (robotsMeta) {
        robotsMeta.setAttribute("content", "index, follow");
      }
    }

    // Cleanup: reset to default when leaving noindex pages
    return () => {
      if (shouldNoIndex && robotsMeta) {
        robotsMeta.setAttribute("content", "index, follow");
      }
    };
  }, [location.pathname]);
};
